/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable arrow-body-style */
import { Box, Typography , Stack , MenuItem } from '@mui/material';
import Label from 'src/components/Label';
// utils
import { fDate } from '../../../../utils/formatTime';
// @types
// components
import Image from '../../../../components/Image';
import TextMaxLine from '../../../../components/TextMaxLine';
import SvgIconStyle from '../../../../components/SvgIconStyle';
import { StyledAvatar, StyledCardContainer, StyledCardContent } from '../styles';

import { TableMoreMenu } from 'src/components/table';

import { useState } from 'react';
import Iconify from 'src/components/Iconify';
import { Track } from 'src/@types/tracks';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

type Props = {
  track: Track;
  index?: number;
  handleEditRow(): void;
  handleDeleteRow(): void;
};

export default function TrackCard({ track, index, handleDeleteRow, handleEditRow }: Props) {
  return (
    <StyledCardContainer>
      <Box sx={{ position: 'relative' }}>
        <SvgIconStyle
          src="https://minimal-assets-api-dev.vercel.app/assets/icons/shape-avatar.svg"
          sx={{
            zIndex: 9,
            width: 80,
            height: 36,
            bottom: -15,
            position: 'absolute',
            color: 'background.paper',
          }}
        />
        <StyledAvatar alt={track.title} src={track.icon} />
        <Image alt="cover" src={track.image} ratio="4/3" />
      </Box>

      <CardContent track={track} handleDeleteRow={handleDeleteRow} handleEditRow={handleEditRow} />
    </StyledCardContainer>
  );
}

// ----------------------------------------------------------------------

type TrackContentProps = {
  track: Track;
  handleEditRow(): void;
  handleDeleteRow(): void;
};

function CardContent({ track, handleEditRow, handleDeleteRow }: TrackContentProps) {
  return (
    <StyledCardContent>
      <Stack>
        <Stack
          direction={'row'}
          width={'100%'}
          justifyContent={'space-between'}
          alignItems={'center'}
          mb={1}
        >
          <Typography variant="caption" component="div" color={'text.disabled'}>
            {fDate(track.createdAt as string)}
          </Typography>
          <ToolBar onEditRow={handleEditRow} onDeleteRow={handleDeleteRow} row={track} />
        </Stack>
        <Stack
          direction={'row'}
          width={'100%'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <TextMaxLine sx={{ width: 'auto !important' }} variant={'subtitle2'} line={2} persistent>
            {track.title}
          </TextMaxLine>

          <TextMaxLine
            sx={{ width: 'auto !important' }}
            variant={'body2'}
            color={'text.disabled'}
            line={2}
            persistent
          >
            {track?.category?.title}
          </TextMaxLine>
        </Stack>
        <Stack direction={'row'} spacing={1} sx={{ alignSelf: 'flex-start' }}>
          {/* track-display-order T3: the website lists a path's tracks by this. */}
          <Label color="default" variant="ghost" data-testid="track-card-order">
            {`Order ${typeof track.order === 'number' ? track.order : 0}`}
          </Label>
          {track.isCareerTrack ? (
            <Label color="primary" variant="ghost">
              Career track
            </Label>
          ) : null}
        </Stack>
        <Typography
          gutterBottom
          variant="caption"
          height={'150px'}
          component="div"
          color={'text.disabled'}
        >
          {track.description}
        </Typography>
      </Stack>
    </StyledCardContent>
  );
}

export const ToolBar = ({
  onEditRow,
  row,
  onDeleteRow,
}: {
  row: Track;
  onEditRow(): void;
  onDeleteRow(): void;
}) => {
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableMoreMenu
      open={openMenu}
      onOpen={handleOpenMenu}
      onClose={handleCloseMenu}
      actions={
        <>
        
          <MenuItem
            onClick={() => {
              onEditRow();
              handleCloseMenu();
            }}
          >
            <Iconify icon={'eva:edit-fill'} />
            Edit
          </MenuItem>
          <MenuItem
            onClick={() => {
              onDeleteRow();
              handleCloseMenu();
            }}
            sx={{ color: 'error.main' }}
          >
            <Iconify icon={'eva:trash-2-outline'} />
            Delete
          </MenuItem>
        </>
      }
    />
  );
};
